import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";

interface QuizDialogHeaderProps {
  navigateBack: () => void;
}

export function QuizDialogHeader(props: QuizDialogHeaderProps) {
  const { navigateBack } = props;

  return <PageHeaderTopRow onClickBack={navigateBack} />;
}
